const baseUrl = (process.env.VUE_APP_S3_BASE_URL || '').replace(/\/+$/, '');

export const buildS3Url = (path) => {
  if (!baseUrl) {
    return path;
  }

  const cleanPath = path.replace(/^\/+/, '');
  return `${baseUrl}/${cleanPath}`;
};

export const listS3Objects = async (prefix) => {
  if (!baseUrl) {
    return [];
  }

  const query = `${baseUrl}?list-type=2&prefix=${encodeURIComponent(prefix)}`;
  const response = await fetch(query);

  if (!response.ok) {
    return [];
  }

  const xmlText = await response.text();
  const xml = new DOMParser().parseFromString(xmlText, 'application/xml');
  const keys = Array.from(xml.getElementsByTagName('Key'))
    .map((node) => node.textContent)
    .filter((key) => key && !key.endsWith('/'));

  return keys.map((key) => encodeURI(buildS3Url(key)));
};

const configBaseUrl = (process.env.VUE_APP_S3_CONFIG_BASE_URL || '').replace(/\/+$/, '');

export const fetchS3Json = async (path, fallback = null) => {
  if (!configBaseUrl) {
    return fallback;
  }

  const cleanPath = path.replace(/^\/+/, '');
  const url = `${configBaseUrl}/${cleanPath}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      return fallback;
    }
    return await response.json();
  } catch (error) {
    return fallback;
  }
};
